Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    formFieldWrapperLabelLineHeight: "20px",
    formFieldWrapperLabelFontWeight: 400,
    formFieldWrapperLabelFontSizeSmall: 14,
    formFieldWrapperLabelFontSizeDefault: 16,
    formFieldWrapperLabelLineHeightSmall: "20px",
    formFieldWrapperLabelLineHeightDefault: "24px",
    formFieldWrapperLabelFontWeightSmall: 400,
    formFieldWrapperLabelFontWeightDefault: 400,
    formFieldWrapperLabelColorDefault: tokens.themeInkDefault,
    formFieldWrapperLabelColorDisabled: tokens.themeInkDisabled,
    formFieldWrapperLegendFontSizeSmall: 14,
    formFieldWrapperLegendFontSizeDefault: 16,
    formFieldWrapperLegendLineHeightSmall: "18px",
    formFieldWrapperLegendLineHeightDefault: "20px",
    formFieldWrapperLegendFontWeight: 600,
    formFieldWrapperLegendColorDefault: tokens.themeInkDefault,
    formFieldWrapperLegendColorDisabled: tokens.themeInkDisabled,
    formFieldWrapperSupportTextFontSize: 14,
    formFieldWrapperSupportTextFontWeight: 400,
    formFieldWrapperSupportTextLineHeight: "20px",
    formFieldWrapperSupportTextColorDefault: tokens.themeInkSubdued,
    formFieldWrapperSupportTextColorDisabled: tokens.themeInkDisabled,
    formFieldWrapperSpacingInsetHorizontalMobile: 2,
    formFieldWrapperSpacingVertical: 2
  }
};